// src/constants/colors.js

export const COLOR_CATEGORY_MAP = {
  'bg-blue-400':   { color: 'bg-blue-100 border-blue-400',   dotColor: 'bg-blue-400' },
  'bg-green-400':  { color: 'bg-green-100 border-green-400', dotColor: 'bg-green-400' },
  'bg-yellow-400': { color: 'bg-yellow-100 border-yellow-400', dotColor: 'bg-yellow-400' },
  'bg-purple-400': { color: 'bg-purple-100 border-purple-400', dotColor: 'bg-purple-400' },
  'bg-pink-400':   { color: 'bg-pink-100 border-pink-400',   dotColor: 'bg-pink-400' },
  'bg-gray-400':   { color: 'bg-gray-100 border-gray-400',   dotColor: 'bg-gray-400' },
}

export const COLOR_CATEGORIES = [
  { color: 'bg-blue-400', label: 'Work' },
  { color: 'bg-green-400', label: 'Personal' },
  { color: 'bg-yellow-400', label: 'Social' },
  { color: 'bg-purple-400', label: 'Health' },
  { color: 'bg-pink-400', label: 'Family' },
  { color: 'bg-gray-400', label: 'Other' },
];

export const APPLE_COLOR_PALETTE = [
  { color: 'bg-orange-100 border-orange-400', dotColor: 'bg-orange-400' },
  { color: 'bg-teal-100 border-teal-400', dotColor: 'bg-teal-400' },
  { color: 'bg-rose-100 border-rose-400', dotColor: 'bg-rose-400' },
  { color: 'bg-indigo-100 border-indigo-400', dotColor: 'bg-indigo-400' },
  { color: 'bg-cyan-100 border-cyan-400', dotColor: 'bg-cyan-400' },
];

export const GOOGLE_COLOR_PALETTE = [
  { color: 'bg-blue-100 border-blue-400', dotColor: 'bg-blue-400' },
  { color: 'bg-green-100 border-green-400', dotColor: 'bg-green-400' },
  { color: 'bg-purple-100 border-purple-400', dotColor: 'bg-purple-400' },
  { color: 'bg-pink-100 border-pink-400', dotColor: 'bg-pink-400' },
  { color: 'bg-yellow-100 border-yellow-400', dotColor: 'bg-yellow-400' },
];

